import { render } from "./MenuAllCoins.vue?vue&type=template&id=921bc578"
import script from "./MenuAllCoins.vue?vue&type=script&lang=js"
export * from "./MenuAllCoins.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__